/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Row, Col,
} from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  WelcomeLabel, InviteHeader,
  InviteDescription,
} from './Forms';
import CustomTrans from './CustomTrans';

const CreateAccountHeader = ({
  company, descLabel, regionFormConfig, detail,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col span={24}>
          <Row
            type="flex"
            style={{ alignItems: 'center', marginTop: '15px' }}
            justify="center"
            gutter={10}
          >
            <WelcomeLabel>{company}</WelcomeLabel>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row
            type="flex"
            style={{ alignItems: 'center', marginTop: '-15px' }}
            justify="center"
            gutter={10}
          >
            <InviteHeader>
              <CustomTrans company={company} label={descLabel} region={regionFormConfig.code} />
            </InviteHeader>
          </Row>
          {detail
            ? (
              <>
                <Row
                  type="flex"
                  style={{ alignItems: 'center', marginTop: '-13px' }}
                  justify="center"
                  gutter={10}
                >
                  <InviteDescription>
                    {t('FORM_USER_ACCOUNT.USER_ACCOUNT_INFO')}
                  </InviteDescription>
                </Row>
              </>
            ) : (
              <></>
            )}
        </Col>
      </Row>
    </>
  );
};

export default CreateAccountHeader;

CreateAccountHeader.propTypes = {
  company: PropTypes.string.isRequired,
  descLabel: PropTypes.string.isRequired,
  regionFormConfig: PropTypes.any.isRequired,
  detail: PropTypes.bool.isRequired,
};
